module.exports = __webpack_public_path__ + "img/icon299.d9b81f59.png";